// A TO's distribution values per period (KD-3896): the first level holding a
// value wins, period > room × season > room, as the API resolves them. Only
// entered values are stored; `null` / `undefined` means "inherit". A margin
// only counts with its type, as pricing applies it.

export const EMPTY_DISTRIBUTION = {
  margin: null,
  isMarginPercent: null,
  allotmentCount: null,
  freeSale: null,
};

export const isSet = (value) =>
  value !== null && value !== undefined && value !== '';

export const hasMargin = (values) =>
  isSet(values?.margin) && isSet(values?.isMarginPercent);

/** Whether a level holds at least one entered value. */
export const hasOwnValue = (values) =>
  hasMargin(values) || isSet(values?.allotmentCount) || isSet(values?.freeSale);

/** The level whose allotment applies: the first one holding a value. */
export const allotmentLevelIndex = (levels) =>
  levels.findIndex((level) => isSet(level?.allotmentCount));

/**
 * `levels` go from the most specific to the least. `contractFreeSale` is the
 * DMC free sale, the authority: the TO only sells free sale where the DMC
 * does, a level can only turn it off.
 */
export const resolveDistribution = (levels, contractFreeSale = false) => {
  const marginLevel = levels.find(hasMargin);
  return {
    margin: marginLevel ? Number(marginLevel.margin) : null,
    isMarginPercent: marginLevel ? marginLevel.isMarginPercent : null,
    allotmentCount: Number(
      levels[allotmentLevelIndex(levels)]?.allotmentCount ?? 0,
    ),
    freeSale:
      Boolean(contractFreeSale) &&
      (levels.find((level) => isSet(level?.freeSale))?.freeSale ?? true),
  };
};

/** One level's values as the API takes them: null inherits. */
export const toDistributionPayload = (values) => {
  const margin = hasMargin(values) ? Number(values.margin) : null;
  return {
    margin,
    isMarginPercent: margin === null ? null : values.isMarginPercent,
    allotmentCount: isSet(values?.allotmentCount)
      ? Number(values.allotmentCount)
      : null,
    freeSale: isSet(values?.freeSale) ? values.freeSale : null,
  };
};
